export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["报价ID"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易者"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["制造商"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["接受者"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["状态"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我给出"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我获得"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外部资产已链接"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我的角色"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入报价ID"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入交易者姓名或ID"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入制造商姓名或ID"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入接受者姓名或ID"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入给出金额"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入获得金额"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择状态"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择资产"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["内部"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外部"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["全部"])}
}